import React, { Component } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableRow,
  TableCell
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { addDays, compareDesc } from 'date-fns';
import CloseIcon from '@material-ui/icons/Close';
import SelectReact from 'react-select';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

import '../../assets/stylesheets/EmployeeAttributes.css';

const initialState = (date) => ({
  invalidContractState: true,
  isOpen: false,
  contracts: [
    {
      positionId: 0,
      contractStart: date || new Date(),
      contractEnd: addDays(date || new Date(), 1)
    }
  ]
});
class ContractInputModal extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState(new Date()) };
  }

  addContract = () => {
    this.setState(prevState => {
      const newContract = {
        positionId: 0,
        contractStart: new Date(),
        contractEnd: addDays(new Date(), 1)
      };
      const updatedContracts = [...prevState.contracts];
      updatedContracts.push(newContract);
      return { contracts: updatedContracts, invalidContractState: true };
    });
  };

  handleSave = () => {
    const { contracts } = this.state;
    const { handleSaveContracts } = this.props;
    handleSaveContracts(contracts);
    this.hideDialog();
  };

  validateContractState = () => {
    const { contracts } = this.state;
    let updatedInvalidContractState = false;
    contracts.forEach(contract => {
      if (contract.positionId < 1) {
        updatedInvalidContractState = true;
      }
      if (compareDesc(contract.contractStart, contract.contractEnd) < 1) {
        updatedInvalidContractState = true;
      }
    });
    this.setState({ invalidContractState: updatedInvalidContractState });
  };

  handlePositionChange = (selectedItem, index) => {
    this.setState(
      prevState => {
        const updatedContracts = [...prevState.contracts];
        updatedContracts[index] = {
          ...prevState.contracts[index],
          positionId: selectedItem.id
        };
        return { contracts: updatedContracts };
      },
      () => this.validateContractState()
    );
  };

  hideDialog = () => {
    this.setState({ isOpen: false });
  };

  removeContract = index => {
    this.setState(
      prevState => {
        const updatedContracts = [...prevState.contracts];
        updatedContracts.splice(index, 1);
        return { contracts: updatedContracts };
      },
      () => {
        const { updateContracts } = this.props;
        const { contracts } = this.state;
        this.validateContractState();
        updateContracts(contracts);
      }
    );
  };

  resetDialog = () => {
    this.setState({ ...initialState(new Date()) }, () => {
      const { updateContracts } = this.props;
      const { contracts } = this.state;
      updateContracts(contracts)
    });
  };

  showDialog = () => {
    this.setState({ isOpen: true });
  };

  mapContracts = (contract, index) => {
    const { contracts } = this.state;
    const { positions } = this.props;
    const displayRemoveButton = contracts.length > 1;
    return (
      <React.Fragment key={`contract-${index}`}>
        <TableRow>
          <TableCell className="attributeLabel">
            {i18n.t('userProfile:position')}
          </TableCell>
          <TableCell className="attributeValue">
            <SelectReact
              menuPlacement="bottom"
              value={positions.filter(
                position => position.id === contract.positionId
              )}
              options={positions}
              onChange={selection =>
                this.handlePositionChange(selection, index)
              }
            />
          </TableCell>
          {displayRemoveButton && (
            <TableCell>
              <Button
                className="ssenseButton ssenseDefault"
                onClick={() => this.removeContract(index)}
              >
                {i18n.t('userProfile:removeContract')}
              </Button>
            </TableCell>
          )}
        </TableRow>
        <TableRow>
          <TableCell className="attributeLabel">
            {i18n.t('userProfile:contractStart')}
          </TableCell>
          <TableCell>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                value={contract.contractStart}
                onChange={date => this.updateContractStart(date, index)}
                format="d MMM yyyy"
              />
            </MuiPickersUtilsProvider>
          </TableCell>
          {displayRemoveButton && <TableCell />}
        </TableRow>
        <TableRow>
          <TableCell className="attributeLabel">
            {i18n.t('userProfile:contractEnd')}
          </TableCell>
          <TableCell>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                value={contract.contractEnd}
                onChange={date => this.updateContractEnd(date, index)}
                format="d MMM yyyy"
                minDate={addDays(contract.contractStart, 1)}
              />
            </MuiPickersUtilsProvider>
          </TableCell>
          {displayRemoveButton && <TableCell />}
        </TableRow>
      </React.Fragment>
    );
  };

  updateContracts = positionIds => {
    const { contracts } = this.state;
    const updatedContracts = contracts.filter((contract) => 
      // this is default contract or position for contract is no longer selected
      contract.positionId === 0 || positionIds.includes(contract.positionId)
    );    
    if (updatedContracts.length !== contracts.length) {
      this.setState(
        () => {
          let updatedInvalidContractState = false;
          if (!updatedContracts.length) {
            updatedContracts.push(initialState(new Date()).contracts[0]);
            updatedInvalidContractState = true;
          }
          return {
            contracts: updatedContracts,
            invalidContractState: updatedInvalidContractState
          };
        },
        () => {
          const { updateContracts } = this.props;
          const { contracts: contractsUpdated } = this.state;
          updateContracts(contractsUpdated);
        });
    }
  };

  updateContractStart = (date, index) => {
    this.setState(
      prevState => {
        const updatedContracts = [...prevState.contracts];
        updatedContracts[index].contractStart = date;
        return { contracts: updatedContracts };
      },
      () => this.validateContractState()
    );
  };

  updateContractEnd = (date, index) => {
    this.setState(
      prevState => {
        const updatedContracts = [...prevState.contracts];
        updatedContracts[index].contractEnd = date;
        return { contracts: updatedContracts };
      },
      () => this.validateContractState()
    );
  };

  render() {
    const { invalidContractState, isOpen, contracts } = this.state;

    return (
      <Dialog
        open={isOpen}
        onBackdropClick={this.hideDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle disableTypography>
          <h4>{i18n.t('userProfile:manageContracts')}</h4>
          <IconButton
            aria-label="close"
            className="modalButtonClose"
            onClick={this.hideDialog}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent scroll="body">
          <Table>
            <TableBody>
              {contracts.map(this.mapContracts)}
              <TableRow>
                <TableCell>
                  <Button
                    className="ssenseButton ssenseSecondary"
                    onClick={this.addContract}
                    disabled={invalidContractState}
                  >
                    {i18n.t('userProfile:addAnotherContract')}
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            alignItems="flex-end"
            justify="flex-end"
            className="createEditProductCreateRow"
          >
            <Grid item>
              <Button
                className="ssenseButton ssensePrimary"
                onClick={this.handleSave}
                disabled={invalidContractState}
              >
                {i18n.t('save')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="ssenseButton ssenseDefault"
                onClick={this.hideDialog}
              >
                {i18n.t('cancel')}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

ContractInputModal.propTypes = {
  positions: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSaveContracts: PropTypes.func.isRequired,
  updateContracts: PropTypes.func.isRequired
};

export default ContractInputModal;
